import classes from "./MeetingStairs.module.css"
import {useEffect, useState} from "react";
import logo from "../../../../store/logo.png"
import stairs from "../../../../store/stairsQ.png"
import axios from "axios";
import { path, assetsBaseUrl } from "../../../../routes";
import {CircularProgress} from "@mui/material";

const MeetingStairs = (props) => {

    const [meetings, setMeetings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentIndexA, setCurrentIndexA] = useState(0);

    const fetch_meetings = async () =>{
        setLoading(true)
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        const actTime = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}T${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds() ).padStart(2, "0")}`;

        const response = await axios.get(`${path}/getRecordsNowV2?orgID=62BDEE7F-9CE9-41BE-A80C-EF69F045D56C&day=${actTime}`);
        setMeetings(response.data)
        setCurrentIndexA(0)
        if (response.data.length == 0) {props.reset()}
        setLoading(false)
    }

    const back_handler = () => {
        props.changeStep(1)
    }

    useEffect(() => {
        const intervalfetchmeeting = setInterval(() => {
            fetch_meetings()
        }, 20 * 1000);
        return () => {
            clearInterval(intervalfetchmeeting);
        };
    }, []);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % meetings.length);
        }, 5000);
        return () => {
            clearInterval(intervalId);
        };
    }, [meetings]);
    useEffect(() => {
        fetch_meetings()
    }, []);
    return <div className={classes.cont}>
        <div className={classes.logo}>
            {loading && <CircularProgress color="secondary" size={100}/>}
            {meetings.length != 0 && <img src={`${assetsBaseUrl}${meetings[currentIndexA].path}`} className={classes.logo}/>}
            {meetings.length != 0 && <h2>{meetings[currentIndexA].room}</h2>}
        </div>
        <div className={classes.stairs}>
            <img src={stairs}/>
        </div>
    </div>
}
export default MeetingStairs